<template>
abc
</template>

<script>
export default {
  props: {
    item: {},
  },
  methods: {
    markChecked() {

    },
  }
}
</script>
